<template>
  <div>
    <Header v-if="this.userInfo.user.permission == 'super_admin'" />

    <HodHeader v-if="this.userInfo.user.permission == 'hod'" />
    <CoordinateHeader v-if="this.userInfo.user.permission == 'co-ordinator'" />
    <InstructorHeader v-if="this.userInfo.user.permission == 'instructor'" />

    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />

    <div class="py-10">
      <div class="container px-6 mx-auto max-w-[1200px] flex flex-col gap-10">
        <div>
          <form
            ref="addCourseRef"
            class="rounded-3xl pt-10 px-6 md:px-10 pb-2 heightfix overflow-y-auto"
            style="box-shadow: 0px 2px 20px 0px #105c8e26"
            @submit.prevent="createCourse"
          >
            <div class="flex items-center justify-between flex-wrap">
              <h1
                class="py-2 text-xl text-center font-bold text-blues w-full md:w-auto"
              >
                Assign Student
              </h1>

              <router-link
                :to="{ name: 'AdminCoursess' }"
                class="bg-blues text-white rounded-lg text-sm font-semibold px-3 py-1"
                >Back</router-link
              >
            </div>

            <div class="py-10 flex flex-col gap-6">
              <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
                <!-- <div class="flex flex-col gap-3">
                      <label for="title" class="text-sm">Title <span class="text-red-400">*</span></label>
                      <input id="title" type="text" required
                        class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none" />
                    </div> -->
                <div class="flex flex-col gap-3">
                  <label for="batch_year" class="text-sm"
                    >Batch Year <span class="text-red-400">*</span></label
                  >
                  <select
                    id="batch_year"
                    required
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  >
                    <option value="" selected disabled>Select Batch</option>
                    <option
                      v-for="batch_year in batch_years"
                      :key="batch_year.year"
                      :value="batch_year.id"
                    >
                      {{ batch_year.year }}
                    </option>
                  </select>
                </div>
                <div class="flex flex-col gap-3">
                  <label for="program_name" class="text-sm flex gap-2"
                    >Program Name <span class="text-red-400">*</span>
                    <font-awesome-icon
                      @click="isPrograms = true"
                      class="text-base text-green-500 self-end mb-1 h-4 w-4 cursor-pointer hover:text-green-800"
                      :icon="['fas', 'plus']"
                      title="Add Category"
                    />
                  </label>
                  <select
                    id="program_name"
                    required
                    @change="getProgramsFilter()"
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  >
                    <option value="" selected disabled>Select Programs</option>
                    <option
                      v-for="program in programs"
                      :key="program.id"
                      :value="program.name"
                    >
                      {{ program.name }}
                    </option>
                  </select>
                  
                </div>

                <!-- new program -->
                <div class="relative w-full flex flex-col gap-3 hidden">
                  <label for="program_name" class="text-sm flex gap-2"
                    >Program Name <span class="text-red-400">*</span>
                    <font-awesome-icon
                      @click="isPrograms = true"
                      class="text-base text-green-500 self-end mb-1 h-4 w-4 cursor-pointer hover:text-green-800"
                      :icon="['fas', 'plus']"
                      title="Add Category"
                    />
                  </label>
                  <!-- Dropdown Button -->
                  <div
                    @click="toggleDropdown"
                    class="bg-white border border-gray-300 rounded-md px-4 py-2 cursor-pointer flex justify-between items-center"
                  >
                    <span class="text-sm text-gray-700">
                      {{ selectedProgram?.name || "Select Program" }}
                    </span>
                    <svg
                      class="w-4 h-4 text-gray-500"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M19 9l-7 7-7-7"
                      />
                    </svg>
                  </div>

                  <!-- Dropdown List -->
                  <div
                    v-if="dropdownOpen"
                    class="absolute z-10 mt-20 w-full bg-white border border-gray-200 rounded-md shadow-lg max-h-40 overflow-y-auto"
                  >
                    <div
                      v-for="program in programs"
                      :key="program.id"
                      class="flex justify-between items-center px-4 py-2 text-sm text-gray-800 hover:bg-gray-100"
                    >
                      <!-- Select Action -->
                      <span
                        @click="selectProgram(program)"
                        id="program_name"
                        class="cursor-pointer flex-1 "
                      >
                        {{ program.name }}
                      </span>

                      <!-- Actions -->
                      <div class="flex gap-2 ml-2 text-xs">
                        <span
                          class="text-blue-600 cursor-pointer hover:underline"
                          @click.stop="editProgram(program)"
                        >
                          Edit
                        </span>
                        <span
                          class="text-red-600 cursor-pointer hover:underline"
                          @click.stop="deleteProgram(program)"
                        >
                          Delete
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Edit Modal -->
                <div
                  v-if="editModalOpen"
                  class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
                >
                  <div class="bg-white p-6 rounded-lg w-[90%] max-w-md">
                    <h2 class="text-lg font-semibold mb-4">Edit Program</h2>
                    <input
                      v-model="editProgramData.name"
                      type="text"
                      id="programname"
                      class="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring focus:ring-blue-200"
                    />
                    <div class="flex justify-end gap-2 mt-4">
                      <button
                        @click="editModalOpen = false"
                        class="px-4 py-2 text-sm bg-gray-300 rounded hover:bg-gray-400"
                      >
                        Cancel
                      </button>
                      <button
                        @click="saveProgram"
                        class="px-4 py-2 text-sm bg-blue-600 text-white rounded hover:bg-blue-700"
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
                <!-- Delete  Modal -->
                <div
                  v-if="deleteModalOpen"
                  class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
                >
                  <div
                    class="bg-white p-6 rounded-lg w-[90%] max-w-md shadow-lg"
                  >
                    <h2 class="text-lg font-semibold mb-4 text-gray-800">
                      Confirm Deletion
                    </h2>
                    <p class="text-sm text-gray-600 mb-4">
                      Are you sure you want to delete
                      <b>{{ programToDelete.name }}</b
                      >?
                    </p>
                    <div class="flex justify-end gap-3">
                      <button
                        @click="deleteModalOpen = false"
                        class="px-4 py-2 text-sm bg-gray-200 rounded hover:bg-gray-300"
                      >
                        Cancel
                      </button>
                      <button
                        @click="programdelete"
                        class="px-4 py-2 text-sm bg-red-600 text-white rounded hover:bg-red-700"
                      >
                        Delete
                      </button>
                    </div>
                  </div>
                </div>

                <div class="flex flex-col gap-3">
                  <label for="department" class="text-sm flex gap-2"
                    >Departments <span class="text-red-400">*</span>

                    <font-awesome-icon
                      @click="isDepartment = true"
                      class="text-base text-green-500 self-end mb-1 h-4 w-4 cursor-pointer hover:text-green-800"
                      :icon="['fas', 'plus']"
                      title="Add Category"
                    />
                  </label>
                  <select
                    id="department"
                    @change="getInstructorListByFilter(), getSemesterFilter()"
                    required
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  >
                    <option value="" selected disabled>
                      Select Department
                    </option>
                    <option
                      v-for="department in departments"
                      :key="department.id"
                      :value="department.id"
                    >
                      {{ department.name }}
                    </option>
                  </select>
                </div>
                <div class="flex flex-col gap-3">
                  <label for="semester" class="text-sm"
                    >Semester<span class="text-red-400">*</span></label
                  >
                  <select
                    id="semester"
                    required
                    class="bg-[#F9FAFC] rounded-lg text-sm w-full p-3 border-none outline-none"
                  >
                    <!-- <option v-for="program in programs" :key="program.id" :value="program.name">
                          {{ category.name }}
                        </option> -->
                    <option value="" selected disabled>Select Semester</option>

                    <option
                      v-for="semetser in semetser_list"
                      :key="semetser"
                      :value="semetser.id"
                    >
                      {{ semetser.semester }}
                    </option>

                    <!-- <option value="I">I</option>
                    <option value="II">II</option>
                    <option value="III">III</option>
                    <option value="IV">IV</option>
                    <option value="V">V</option>
                    <option value="VI">VI</option> -->
                    <!-- ('I', 'I'),
                        ('II', 'II'),
                        ('III', 'III'),
                        ('IV', 'IV'),
                        ('V', 'V'),
                        ('VI', 'VI'), -->
                  </select>
                </div>
              </div>

              <div class="flex items-center gap-3 flex-wrap">
                <button
                  type="submit"
                  :disabled="disable_submit == true"
                  :class="
                    this.disable_submit == true
                      ? 'bg-gray-200 text-black cursor-not-allowed'
                      : 'text-greens border border-greens cursor-pointer'
                  "
                  class="rounded-lg text-lg px-6 py-1.5 font-semibold"
                >
                  Assign
                </button>
                <img
                  v-if="disable_submit"
                  src="@/assets/loading.gif"
                  alt="loading"
                  class="w-6 h-6 object-contain"
                />

                <!-- <button
                  type="submit"
                  class="text-greens border border-greens rounded-lg text-lg font-semibold px-6 py-1.5"
                >
                  Assign
                </button> -->
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Admin/Header.vue";
import HodHeader from "@/components/Hod/Header.vue";
import CoordinateHeader from "@/components/Coordinate/Header.vue";
import InstructorHeader from "@/components/Instructor/Header.vue";

import axios from "axios";
import { mapGetters } from "vuex";
import FlashMessage from "@/components/FlashMessage.vue";

export default {
  components: {
    Header,
    FlashMessage,
    HodHeader,
    CoordinateHeader,
    InstructorHeader,
  },

  data() {
    return {
      categories: null,
      info: null,
      msgverify: "",
      messages: {
        text: "",
        type: "null",
      },
      is_CategoryPopup: false,
      description: "<h4>Write your course content</h4>",
      batch_years: [],
      programs: [],
      departments: [],
      isDepartment: false,
      isPrograms: false,
      instructor_lists: [],
      semetser_list: [],
      disable_submit: false,
      editProgramData: {},
      dropdownOpen: false,
      editModalOpen: false,
      deleteModalOpen:false,
    };
  },

  computed: mapGetters(["userInfo"]),

  async created() {
    // this.getDepartments();
    this.getPrograms();

    axios
      .get(
        `${process.env.VUE_APP_API}/batch-list/?Key=${this.userInfo.token_key}`
      )
      .then((res) => {
        this.batch_years = res.data.data;
      });

    axios
      .get(`${process.env.VUE_APP_API}/category/?format=json`)
      .then((res) => {
        this.categories = res.data.data;
      });
  },

  methods: {
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },
    selectProgram(program) {
      this.selectedProgram = program;
      this.dropdownOpen = false;
      this.getProgramsFilter(program.name);
    },
    editProgram(program) {
      this.editProgramData = { ...program };
      this.editModalOpen = true;
    },
     deleteProgram(program) {
      this.programToDelete = program;
      this.deleteModalOpen = true;
    },
    saveProgram() {
      let bodyVal = {
        name: this.editProgramData.name,
      };

      axios
        .put(
          `${process.env.VUE_APP_API}/program/detail/${this.editProgramData.id}/?Key=${this.userInfo.token_key}`,
          bodyVal
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: "Program Added successfully",
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.editModalOpen = false;
              this.getPrograms();
            }, 1500);
          } else {
            this.messages = {
              text: response.data.message,
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 2000);
          }
        });
    },
     programdelete() {
      let bodyVal = {
        name: this.programToDelete.name,
      };

      axios
        .delete(
          `${process.env.VUE_APP_API}/program/detail/${this.programToDelete.id}/?Key=${this.userInfo.token_key}`,
          bodyVal
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: "Program Added successfully",
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.deleteModalOpen = false;
              this.getPrograms();
            }, 1500);
          } else {
            this.messages = {
              text: response.data.message,
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 2000);
          }
        });
    },
    getInstructorListByFilter() {
      let department_name = document.getElementById("department").value;

      axios
        .get(
          `${process.env.VUE_APP_API}/instructor_all/?Key=${this.userInfo.token_key}&department__name=${department_name}`
        )
        .then((res) => {
          console.log(res);
          this.instructor_lists = res.data.products;
        });
    },

    getProgramsFilter() {
      let program_name = document.getElementById("program_name").value;

      axios
        .get(
          `${process.env.VUE_APP_API}/department-list/?Key=${this.userInfo.token_key}&program__name=${program_name}`
        )
        .then((res) => {
          this.departments = res.data.data;
        });
    },

    getSemesterFilter() {
      let batch_year = 1;
      let department_id = document.getElementById("department").value;
      // console.log(index);
      axios
        .get(
          `${process.env.VUE_APP_API}/semetser-get/?Key=${this.userInfo.token_key}&department__id=${department_id}&batch__id=${batch_year}`
        )
        .then((res) => {
          // this.semetser_list = res.data.data;
          this.semetser_list = res.data.data;
        });
    },

    AddPrograms(el) {
      this.disable_submit = true;
      let bodyVal = {
        name: el.target.elements.name.value,
      };

      axios
        .post(
          `${process.env.VUE_APP_API}/program_create/?Key=${this.userInfo.token_key}`,
          bodyVal
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: "Program Added successfully",
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.isPrograms = false;
              this.getPrograms();
              this.$refs.addProgramsRef.reset();
            }, 1500);
          } else {
            this.messages = {
              text: response.data.message,
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 2000);
          }
        })
        .finally(() => {
          this.disable_submit = false;
        });
    },

    getPrograms() {
      axios
        .get(
          `${process.env.VUE_APP_API}/program-list/?Key=${this.userInfo.token_key}`
        )
        .then((res) => {
          this.programs = res.data.data;
        });
    },

    getDepartments() {
      axios
        .get(
          `${process.env.VUE_APP_API}/department-list/?Key=${this.userInfo.token_key}`
        )
        .then((res) => {
          this.departments = res.data.data;
        });
    },

    categoryget() {
      axios
        .get(`${process.env.VUE_APP_API}/category/?format=json`)
        .then((res) => {
          this.categories = res.data.data;
        });
    },

    AddDepartment(el) {
      this.disable_submit = true;
      let bodyVal = {
        name: el.target.elements.name.value,
        program: el.target.elements.program_name.value,
      };

      axios
        .post(
          `${process.env.VUE_APP_API}/department_create/?Key=${this.userInfo.token_key}`,
          bodyVal
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: "Department Added successfully",
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.isDepartment = false;
              this.getDepartments();
              this.$refs.addDepartment.reset();
            }, 1500);
          } else {
            this.messages = {
              text: response.data.message,
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 2000);
          }
        })
        .finally(() => {
          this.disable_submit = false;
        });
    },

    async createCourse(e) {
      this.disable_submit = true;
      let token = this.userInfo.token_key;
      let urls = `${process.env.VUE_APP_API}/assign-student-permission/semester/?Key=${token}`;
      let HeaderVal = new FormData();

      HeaderVal.append("batch", e.target.elements.batch_year.value);
      //   HeaderVal.append("program_name", e.target.elements.program_name.value);
      HeaderVal.append("department", e.target.elements.department.value);
      HeaderVal.append("semester", e.target.elements.semester.value);

      await axios
        .post(urls, HeaderVal)
        .then((response) => {
          if (response.data.status == 200) {
            this.messages = {
              text: "Student Assigned successfully",
              type: "success",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
              this.$refs.addCourseRef.reset();
              this.$router.push({
                name: "AdminCoursess",
              });
            }, 1500);
          } else {
            this.messages = {
              text: " Event Faild",
              type: "error",
            };
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "null",
              };
            }, 2000);
          }
        })
        .finally(() => {
          this.disable_submit = false;
        });
    },
  },
};
</script>

<style scoped></style>
